import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { MemberDto } from '@services/api'
import { MssEmailStatus } from '@services/dtos'
import MemberAutocomplete from '@components/MemberAutocomplete'
import { setMssFilters } from '@state/reducers/mssReducer'

const MssTableToolbar = () => {
  const [selectedDoctor, setSelectedDoctor] = useState<MemberDto | null>(null)

  const dispatch = useAppDispatch()
  const { filters, doctors } = useAppSelector(({ mss, member }) => ({
    filters: mss.filters,
    doctors: member.members,
  }))

  const handleMemberSelect = (member: MemberDto | null) => {
    setSelectedDoctor(member)
    dispatch(setMssFilters({ doctorId: member?.id }))
  }

  useEffect(() => {
    if (!filters.doctorId && doctors.datas.length > 0) {
      setSelectedDoctor(doctors.datas[0])
      dispatch(setMssFilters({ doctorId: doctors.datas[0].id }))
    }
  }, [doctors])

  return (
    <div className="ml-6 mt-4 flex items-center flex-wrap">
      <div className="w-40 mr-2">
        <MemberAutocomplete
          label="Médecin"
          value={selectedDoctor}
          onChange={handleMemberSelect}
        />
      </div>
      <FormControl size="small" className="ml-6">
        <InputLabel>Statut</InputLabel>
        <Select
          value={filters.status}
          onChange={(ev: SelectChangeEvent<string>) =>
            dispatch(
              setMssFilters({ status: ev.target.value as MssEmailStatus }),
            )
          }
          style={{
            minWidth: '120px',
            marginRight: 6,
          }}
          size="small"
        >
          <MenuItem value={MssEmailStatus.TO_PROCESS}>A traiter</MenuItem>
          <MenuItem value={MssEmailStatus.PROCESSED}>Traités</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default MssTableToolbar
